import React, {useState} from 'react';
import Modal from '../UI/modals/Modal';
import TenantsList from './TenantsList';
import AppConstants from '../../Constants/AppConstants';
import {ToastContainer} from 'react-toastify';

const TenantChangeButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <button
        className="flex items-center gap-[10px] px-[12px] pt-[8px] text-sm text-[#000000]"
        onClick={() => setIsOpen(true)}>
        <svg
          width="19px"
          height="19px"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M18 10L21 7M21 7L18 4M21 7H7M6 14L3 17M3 17L6 20M3 17H17"
            stroke="#146d55"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        Switch Project
      </button>

      {isOpen && (
        <Modal onCloseModal={() => setIsOpen(false)}>
          <div className=" max-w-[600px] max-h-[90dvh]  absolute right-0 left-0  md:top-0 bottom-0 mx-auto my-auto w-full h-full grid place-items-start bg-white  backdrop-blur-sm z-50  rounded-md">
            <TenantsList closeModal={() => setIsOpen(false)} />
          </div>
        </Modal>
      )}
    </>
  );
};

export default TenantChangeButton;
